/* Shared browser-window chrome for the recreated LinksOS views. */
export default function FrameShell({ children, caption, maxWidth, domain = 'course.mygolflinks.com' }) {
  return (
    <div style={{ maxWidth }}>
      <div
        style={{
          background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 14,
          overflow: 'hidden', boxShadow: '0 2px 6px rgba(19,43,30,0.06), 0 28px 70px rgba(19,43,30,0.18)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '10px 14px', background: 'var(--card)', borderBottom: '1px solid var(--line-soft)' }}>
          {[0, 1, 2].map((i) => (
            <span key={i} style={{ width: 9, height: 9, borderRadius: '50%', background: 'rgba(31,46,38,0.18)' }} />
          ))}
          <span className="mono" style={{ fontSize: 10.5, color: 'var(--faint)', marginLeft: 8 }}>
            {domain}
          </span>
        </div>
        {children}
      </div>
      {caption && (
        <p className="mono" style={{ fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--faint)', marginTop: 12, textAlign: 'center' }}>
          {caption}
        </p>
      )}
    </div>
  );
}
